import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Switch, Route, useParams,useHistory } from 'react-router-dom';

import { MAKER_CHECKER_EVENT_LABEL_MLE, MAKER_CHECKER_EVENT_TYPES_MLE } from 'utils/constants/commonValues';

import './MleRequestedApproval.scss'; // Tab styling
import { CHECKER_BASE_URL, getCheckerData, isCheckerActionable, isCheckerSectionDataExist } from './checker.utils';
import { BreadCrumb, Timelinev1 } from 'components';
import OwnershipDetailsAccordion from 'components/MleMakerChecker/OwnershipDetailsAccordion';
import { BUSINESS_SECTION_TYPE_MLE } from 'components/Onboarding/Mle/BusinessTab/contants';
import { UBO_SECTION_TYPE,MERCHANT_SECTION_TYPE } from 'components/Onboarding/Mle/UobTab/constant';
import BusinessDetailsAccordian from 'components/MleMakerChecker/BusinessDetailsAccordian';
import RiskDetailsAccordian from 'components/MleMakerChecker/RiskDetailsAccordian';
import ErrorCard from 'components/ErrorCard/ErrorCard';
import { MLE_ONBOARDING } from './checker.constants';
import { filterSectionCheckerData } from 'components/MleMakerChecker/mleMakerChecker.utils';
import MerchantDetailsAccordian from 'components/MleMakerChecker/MerchantDetailsAccordian';

const baseUrl = CHECKER_BASE_URL;

// Tab Definitions
const tabs = [
  {
    sectionType: BUSINESS_SECTION_TYPE_MLE,
    name: 'Business Details',
    component: (props) => {
      const { draftData, checkerRequestData, auth, isViewMode } = props;
      
      return (
        <BusinessDetailsAccordian 
          data={draftData?.data || draftData}
          additionalData={checkerRequestData}
          auth={auth}
          isViewMode={isViewMode}
        />
      );
    },
    nextPath: (id) => `${baseUrl}${MAKER_CHECKER_EVENT_TYPES_MLE.ubo.toLowerCase()}/${id}`,
    path: (id) => `${baseUrl}${MAKER_CHECKER_EVENT_TYPES_MLE.business.toLowerCase()}/${id}`,
    previousPath: `${baseUrl}`,
    status: (checkerData) => isCheckerSectionDataExist(checkerData, MAKER_CHECKER_EVENT_TYPES_MLE.ubo.toLowerCase()) ? 'Open' : '',
    tabId: 1,
    permission: '',
    tabname: MAKER_CHECKER_EVENT_TYPES_MLE.business.toLowerCase()
  },
  {
    sectionType: UBO_SECTION_TYPE,
    name: 'Ownership Details',
    component: (props) => {
      const { draftData, checkerRequestData, auth, isViewMode } = props;
      
      if (!draftData || Object.keys(draftData).length === 0) {
        return (
          <div className='errorCardContainer'>
            <ErrorCard 
              text="Please review and approve the business details. This will proceed only after receiving your confirmation."
              isNoResult={false}
            />
          </div>
        );
      }
      return (
        <OwnershipDetailsAccordion
          data={draftData?.data || draftData}
          additionalData={checkerRequestData}
          auth={auth}
          isViewMode={isViewMode}
        />
      );
    },
    nextPath: (id) => `${baseUrl}${MAKER_CHECKER_EVENT_TYPES_MLE.risk.toLowerCase()}/${id}`,
    path: (id) => `${baseUrl}${MAKER_CHECKER_EVENT_TYPES_MLE.ubo.toLowerCase()}/${id}`,
    previousPath: (id) => `${baseUrl}${MAKER_CHECKER_EVENT_TYPES_MLE.business.toLowerCase()}/${id}`,
    status: (checkerData) => isCheckerSectionDataExist(checkerData, MAKER_CHECKER_EVENT_TYPES_MLE.ubo.toLowerCase()) ? 'Open' : '',
    tabId: 2,
    permission: '',
    tabname: MAKER_CHECKER_EVENT_TYPES_MLE.ubo.toLowerCase()
  },
  {
    sectionType: MERCHANT_SECTION_TYPE,
    name: 'MID Details',
    component: (props) => {
      const { draftData, checkerRequestData, auth, isViewMode } = props;
      if (!draftData || Object.keys(draftData).length === 0) {
        return (
          <div className='errorCardContainer'>
            <ErrorCard 
              text="Please review and approve the business details. This will proceed only after receiving your confirmation."
              isNoResult={false}
            />
          </div>
        );
      }
      return (
        <MerchantDetailsAccordian
          data={draftData?.data || draftData}
          additionalData={checkerRequestData}
          auth={auth}
          isViewMode={isViewMode}
        />
      );
    },
    nextPath: (id) => `${baseUrl}${MAKER_CHECKER_EVENT_TYPES_MLE.risk.toLowerCase()}/${id}`,
    path: (id) => `${baseUrl}${MAKER_CHECKER_EVENT_TYPES_MLE.merchant.toLowerCase()}/${id}`,
    previousPath: (id) => `${baseUrl}${MAKER_CHECKER_EVENT_TYPES_MLE.business.toLowerCase()}/${id}`,
    status: (checkerData) => isCheckerSectionDataExist(checkerData, MAKER_CHECKER_EVENT_TYPES_MLE.merchant.toLowerCase()) ? 'Open' : '',
    tabId: 2,
    permission: '',
    tabname: MAKER_CHECKER_EVENT_TYPES_MLE.merchant.toLowerCase()
  },
  {
    sectionType: 'risk',
    name: 'Risk Check',
    component: (props) => {
      const { draftData, checkerRequestData, auth, isViewMode } = props;
      if (!draftData || Object.keys(draftData).length === 0) {
        return (
          <div className='errorCardContainer'>
            <ErrorCard 
              text="Please review and approve the ownership details. This will proceed only after receiving your confirmation."
              isNoResult={false}
            />
          </div>
        );
      }

      return (
        <RiskDetailsAccordian
          data={draftData}
          additionalData={checkerRequestData}
          auth={auth}
          isViewMode={isViewMode}
        />
      );
    },
    nextPath: baseUrl,
    path: (id) => `${baseUrl}${MAKER_CHECKER_EVENT_TYPES_MLE.risk.toLowerCase()}/${id}`,
    previousPath: (id) => `${baseUrl}${MAKER_CHECKER_EVENT_TYPES_MLE.ubo.toLowerCase()}/${id}`,
    status: (checkerData) => isCheckerSectionDataExist(checkerData, MAKER_CHECKER_EVENT_TYPES_MLE.risk.toLowerCase()) ? 'Open' : '',
    tabId: 3,
    permission: '',
    tabname: MAKER_CHECKER_EVENT_TYPES_MLE.risk.toLowerCase()
  },
];

const CheckerView = (props) => {
  const { tabname, id } = useParams();
  const { data, auth, checkerData } = props;

  const checkerRequestData = checkerData.tableData.find(
    (tableData) =>
      (
        tableData.eventType === 'MLE_ONBOARDING' ||
        tableData.eventType === MAKER_CHECKER_EVENT_TYPES_MLE.business_update ||
        tableData.eventType === MAKER_CHECKER_EVENT_TYPES_MLE.ownership_update
      ) &&
      String(tableData.makerRequestId) === String(id) // Ensure type consistency
  );

  const isTabDataAvailable = checkerRequestData?.childCheckerResponseList?.some(
    (tabData) => tabData?.makerRequestId > 0
  );
  const history = useHistory();
  if(!checkerRequestData?.childCheckerResponseList){
    history.push('/checker');
    return false;
  }

  return (
    <div className="merchant-legal-entity-wrapper">
      <div className="create-merchant-wrap" id="create-merchant-section">
        <div className="bread-crumbs">
          <h3>{tabname ? MAKER_CHECKER_EVENT_LABEL_MLE(tabname) : ''}</h3>
          <BreadCrumb
            breadCrumbs={[
              {
                name: 'Requested Approval',
                link: "/checker",
              },
              {
                name: tabname ? MAKER_CHECKER_EVENT_LABEL_MLE(tabname) : '',
                link: '',
              },
            ]}
          />
        </div>
        <div className="create-merchant">
          <div className="left-section">
            <Timelinev1
              onboardingProcess={tabs.filter((tab) => {
                // status is used for navigating using timeline and filtering the data
                let status = filterSectionCheckerData(checkerRequestData?.childCheckerResponseList, tab.tabname);
                let parsedData = JSON.stringify(checkerRequestData?.childCheckerResponseList);
                if(parsedData.includes('mleOnboardingFormForPartner') && !status){
                    return false;
                }
                if(parsedData.includes('mleOnboardingForm') && !status){
                  return false;
              }
                if(parsedData.includes('mleOnboardingForm') && !status){
                  return false;
              }
                if (checkerRequestData.eventType !== MLE_ONBOARDING && !status) {
                  return false;
                }
                return true;
              }).map((tab) => {
                return {
                  ...tab,
                  status: tab.status(checkerRequestData),
                  path: tab.path(id),
                  disabled: !isTabDataAvailable,
                };
              })}
              isCreate={false}
              heading="Requested Approval"
            />
          </div>
          <div className="right-section" style={{ marginLeft: '10px' }}>
            <Switch>
              {tabs.map((tab) => (
                <Route exact path={tab.path(':id')} key={tab.tabId}>
                  {tab.component({
                    ...tab,
                    isViewMode: !isCheckerActionable(checkerRequestData, tab.tabname),
                    draftData: getCheckerData(checkerRequestData, tab.tabname),
                    checkerRequestData,
                    auth,
                    tabs,
                    isInEditMode: false,
                  })}
                </Route>
              ))}
            </Switch>
          </div>
        </div>
      </div>
    </div>
  );
};

CheckerView.propTypes = {
  data: PropTypes.object,
  auth: PropTypes.object,
  checkerData: PropTypes.object,
};

const mapStateToProps = ({ auth, checkerData }) => ({
  auth,
  checkerData,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({}, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(CheckerView);
